import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import background_A from '../assets/avatar/background_A.png';
import HairBack from '../atoms/assets/HairBack';
import SkinTone from '../atoms/assets/SkinTone';
import HairFront from '../atoms/assets/HairFront';
import EyeBrows from '../atoms/assets/EyeBrows';
import Beard from '../atoms/assets/Beard';
import Stubble from '../atoms/assets/Stubble';
import Wrinkles from '../atoms/assets/Wrinkles';
const images = require.context( '../assets/avatar', true );

const Holder = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
  img, svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
  .darkbrown { svg { mix-blend-mode: soft-light; opacity: 0.91; path { fill: #2b180d; } }}
  .brown { svg { display: none; }}
  .auburn { svg { mix-blend-mode: color-dodge; opacity: 0.38; path { fill: #854b2c; } }}
  .chestnut { svg { mix-blend-mode: overlay; opacity: 0.55; path { fill: #610050; } }}
  .hazel { svg { mix-blend-mode: color-dodge; opacity: 0.76; path { fill: #454671; } }}
  .red { svg { mix-blend-mode: color-dodge; opacity: 0.78; path { fill: #795643; } }}
  .blonde { svg { mix-blend-mode: screen; opacity: 0.54; path { fill: #e7a175; } }}
  .black { svg { mix-blend-mode: multiply; opacity: 0.6; path { fill: #000; } }}
  .grey { svg { mix-blend-mode: screen; opacity: 0.82; path { fill: #b1b1b1; } }}
`;

function Avatar( { features, currentAvatar } ) {

  const id = currentAvatar;
  const path = `./${id}/${id}`;

  return (
    <Holder>
      <img src={background_A} alt="background"/>
      <HairBack currentAvatar={currentAvatar} images={images} path={path} features={features}/>
      <img src={images( `${path}_clothes.png` )} alt="clothes"/>
      <img src={images( `${path}_faceshape_${features.faceshape}.png` )} alt="face"/>
      <Wrinkles images={images} path={path} features={features}/>
      <Stubble images={images} path={path} features={features}/>
      <img src={images( `${path}_nose_${features.nose}.png` )} alt="nose"/>
      <SkinTone currentAvatar={currentAvatar} images={images} path={path} features={features}/>
      <Beard currentAvatar={currentAvatar} images={images} path={path} features={features}/>
      {features.freckles && features.freckles === 'yes' && <img src={images( `${path}_freckles.png` )} alt="freckles"/>}
      <img src={images( `${path}_lipshape_${features.lipshape}.png` )} alt="lips"/>
      <img src={images( `${path}_eyeshape_${features.eyeshape}_${features.eyecolor}.png` )} alt="eyes"/>
      <HairFront currentAvatar={currentAvatar} images={images} path={path} features={features}/>
      <EyeBrows currentAvatar={currentAvatar} images={images} path={path} features={features}/>
      {features.glasses && <img src={images( `${path}_glasses_${features.glasses}.png` )} alt="glasses"/>}
    </Holder>
  )
}

Avatar.propTypes = {
  features: PropTypes.object,
  currentAvatar: PropTypes.string.isRequired,
};

export default Avatar;
